import Vue from 'vue';
import types from './mutationTypes';
import gateway from '../services/gateway';

export default {
  [types.GATEWAY_LOADED](state, payload) {
    state.gatewayLoaded = payload;
  },
  [types.SET_ACTIVE_GAME](state, payload) {
    state.isGameActive = payload;
  },
  [types.SOCKET_MESSAGE_BETTING](state, payload) {
    if (Object.prototype.hasOwnProperty.call(state.offer, payload.idMatch)) {
      state.offer[payload.idMatch].bettingStatus = payload.bettingStatus;
    }
  },
  [types.SOCKET_CONNECT](state, payload) {
    state.socketConnect = payload;
  },
  [types.SOCKET_KEEP_ALIVE](state, payload) {
    state.socketKeepAlive = payload;
  },
  [types.SET_ACTIVE_BET_TYPE](state, payload) {
    state.activeBetType = payload;
  },
  [types.SET_SINGLE_STAKE](state, payload) {
    state.singleStake = payload;
  },
  [types.SET_COMBO_STAKE](state, payload) {
    state.comboStake = payload;
  },
  [types.SET_OFFER](state, payload) {
    state.offer = payload.data;
  },
  [types.SET_API_LOCATION_CONFIG](state, payload) {
    state.apiLocationConfig = payload;
  },
  [types.SET_GAME_CONFIG](state, payload) {
    state.gameConfig = payload.config;
    state.translations = payload.translations;
    state.singleStake = payload.config.rules_minStake;
    state.comboStake = payload.config.rules_minStake;
  },
  [types.SET_COMPANY_CONFIG](state, payload) {
    state.companyConfig.theme = payload;
  },
  [types.SET_MATCH](state, payload) {
    state.selected.match = payload;
  },
  [types.SET_BET](state, payload) {
    state.selected.bet = payload;
  },
  [types.SET_OUTCOME](state, payload) {
    state.selected.outcome = payload;
  },
  [types.ADD_BET](state, payload) {
    state.addingBet = true;
    state.bets.push(payload);
  },
  [types.RE_BET](state, payload) {
    state.addingBet = true;
    state.rebet = payload.rebet;
    state.bets = payload.bets;
  },
  [types.SET_KEY_EVENT_TIMESTAMP](state, payload) {
    state.keyEventTimestamp = payload;
  },
  [types.EDIT_BET](state, payload) {
    state.editBet = payload;
  },
  [types.CHANGE_BET](state, payload) {
    Vue.set(state.bets, payload.index, payload.data);
    // state.bets[payload.index] = payload.data;
  },
  [types.REMOVE_BET](state, payload) {
    state.addingBet = false;
    state.bets.splice(payload, 1);
  },
  [types.SEND_MESSAGE](state, payload) {
    gateway.sendMessage(payload.action, payload.data);
  },
  [types.CLEAR_BETS](state) {
    state.bets = [];
    state.rebet = null;
  },
  [types.CLEAR_REBET](state) {
    state.rebet = null;
  },
  [types.CLEAR_SELECTED](state) {
    state.selected = {
      match: {},
      bet: {},
      outcome: {},
    };
  },
  [types.UPDATE_SELECTED](state, payload) {
    state.selected = payload;
  },
  [types.UPDATE_MATCH_IN_OFFER](state, payload) {
    state.offer[payload.idMatch] = payload;
  },
  [types.ADD_TO_OFFER](state, payload) {
    Vue.set(state.offer, payload.idMatch, payload);
  },
  [types.UPDATE_OFFER](state, payload) {
    state.offer = payload;
  },
  [types.SET_GLOBAL_BET_STOP](state, payload) {
    state.globalBetstop = payload;
  },
  [types.SET_GAME_ID](state, payload) {
    state.gameId = payload;
  },
  [types.SET_POTENTIONAL_WIN](state, payload) {
    state.potentionalWin = payload;
  },
  [types.SET_SEARCHED_VALUE](state, payload) {
    state.searchedValue = payload;
  },
  [types.SET_SEARCHED_INPUT_ACTIVE](state, payload) {
    state.searchInputActive = payload;
  },
  [types.SET_TICKET_PREVIEW](state, payload) {
    state.ticketPreview = payload;
    state.ticketPreviewShow = true;
  },
  [types.CLOSE_TICKET_PREVIEW](state, payload) {
    state.ticketPreviewShow = payload;
  },
  [types.SET_BETSLIP_BLOCKED](state, payload) {
    console.log('SET_BETSLIP_BLOCKED', payload);
    state.betslipBlocked = payload;
  },
};
